import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';

type ClickTrackingControl = 'button' | 'checkbox' | 'link' | 'list menu';

const getClickTrackingAttributes = (control: ClickTrackingControl, label: string) =>
    getTrackingAttributes({
        trigger: 'click',
        category: `${control} autoTracking`,
        action: `${control} click`,
        label,
    });

export const getButtonTrackingAttributes = (label: string) => getClickTrackingAttributes('button', label);

export const getCheckboxTrackingAttributes = (label: string) => getClickTrackingAttributes('checkbox', label);

export const getLinkTrackingAttributes = (label: string) => getClickTrackingAttributes('link', label);

export const getListMenuTrackingAttributes = (label: string) => getClickTrackingAttributes('list menu', label);
